import { render, staticRenderFns } from "./DocumentModels.vue?vue&type=template&id=21b71b64&scoped=true"
import script from "./DocumentModels.vue?vue&type=script&lang=js"
export * from "./DocumentModels.vue?vue&type=script&lang=js"
import style0 from "./DocumentModels.vue?vue&type=style&index=0&id=21b71b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_xsnsr4smgwphgcec6u2nh24t5a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b71b64",
  null
  
)

export default component.exports